import InvestmentSuitability from './InvestmentSuitability'

export default InvestmentSuitability
